import { useMutation, gql } from '@apollo/client';

import { GET_PROJECT_BY_ID } from 'src/hooks/projects/get-project-by-id.hook';
import { GET_PROJECTS } from 'src/hooks/projects/get-projects.hook';

export const DELETE_TASK = gql`
  mutation deleteTask($taskId: String!) {
    deleteTask(taskId: $taskId)
  }
`;

export const useDeleteTask = () => {
  const [deleteTask] = useMutation(DELETE_TASK, {
    refetchQueries: [GET_PROJECTS, GET_PROJECT_BY_ID],
  });

  return deleteTask;
};
